export enum PersonType {
  FinancialAdviser = "Financial Adviser",
  HNWI = "HNWI",
  Professional = "Professional",
  Other = "Retail Client",
  Corporate = "Corporate",
}
